import { defaultLifeFormValues, LifeFormValues } from "./LifeFormValues";
import { defaultEmployerFormValues, EmployerFormValues } from "../common/EmployerFormValues";
import { BeneficiaryRelationshipType } from "../enums/BeneficiaryRelationshipType";
import { LifeBenefitType } from "../enums/LifeBenefitType";
import { BeneficiaryDesignationStatus } from "../enums/BeneficiaryDesignationStatus";
import { DependentRelationship } from "../enums/DependentRelationship";

export type LifeEmployerFormValues = EmployerFormValues & LifeFormValues & {
    dependentRelationship: DependentRelationship,
    deceasedFirstName: string,
    deceasedLastName: string,
    contactName: string,
    contactPhoneNumber: string,
    contactRelationship: BeneficiaryRelationshipType,
    premiumsPaidThroughDeath: string,
    datePremiumsPaidThrough: string,
    hoursWorkedPerWeek: string,
    activelyAtWork: string,
    reasonCeasedActiveWork: string,
    baseWage: string,
    baseWageFrequency: string,
    baseWageEffectiveDate: string,
    employeeOwnership: boolean,
    employeeOwnershipPercentage: string,
    benefits: [{
        claimed: LifeBenefitType,
        amount: string,
    }],
    beneficiaryDesignationStatus: BeneficiaryDesignationStatus,
    thirdPartyContactName: string,
    thirdPartyContactEmailAddress: string
}

export const defaultLifeEmployerFormValues = {
    ...defaultEmployerFormValues,
    ...defaultLifeFormValues,
    dependentRelationship: '' as DependentRelationship,
    deceasedFirstName: '',
    deceasedLastName: '',
    contactName: '',
    contactPhoneNumber: '',
    contactRelationship: '',
    premiumsPaidThroughDeath: '',
    datePremiumsPaidThrough: '',
    hoursWorkedPerWeek: '',
    activelyAtWork: '',
    reasonCeasedActiveWork: '',
    baseWage: '',
    baseWageFrequency: '',
    baseWageEffectiveDate: '',
    employeeOwnership: false,
    employeeOwnershipPercentage: '',
    benefits: [{
        claimed: '',
        amount: ''
    }],
    beneficiaryDesignationStatus: '',
    thirdPartyContactName: '',
    thirdPartyContactEmailAddress: ''
}